import script from "./OfferDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferDetails.vue?vue&type=script&setup=true&lang=js"

import "./OfferDetails.vue?vue&type=style&index=0&id=6eff9f69&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eff9f69"]])

export default __exports__